import { render, staticRenderFns } from "./PermList.vue?vue&type=template&id=3f3f88fe&"
import script from "./PermList.vue?vue&type=script&lang=js&"
export * from "./PermList.vue?vue&type=script&lang=js&"
import style0 from "./PermList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports